import { sendRequest } from 'api/sendRequest';
import { OneOnOneMarkAsCompleteRequest, OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import { endpoints } from 'constants/endpoints';

import { updateOneOnOneDetailsI } from '../services';

export const getOneOnOneInstanceDetailsApi = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.instancePage(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

export const getOneOnOneInstanceDetailsFromMasterIdApi = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.instanceDetailsFromMasterId(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

export const updateOneOnOneInstanceDetailsApi = ({
  masterId,
  instanceId,
  duration,
  isEditSingleMeeting,
  recurrenceRule,
  startDate,
  startTimeTs,
}: updateOneOnOneDetailsI & OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.updateInstancePage(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      isEditSingleMeeting,
    },
    body: {
      duration,
      recurrenceRule,
      startDate,
      startTimeTs,
    },
  });
};

export const cancelOneOnOneMeetingApi = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.cancelInstance(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

export const archiveOneOnOneMeetingApi = ({
  masterId,
  isArchive,
}: {
  isArchive: boolean;
} & OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.archiveInstance(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      isArchive,
    },
  });
};

export const getRelationToLoggedInEmployeeApi = ({ employeeId }) => {
  const url = endpoints.oneOnOneRevamped.relation;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      employeeId,
    },
  }) as Promise<{
    entity: 'MANAGER' | 'SKIP_MANAGER' | 'PEER' | 'REPORTEE' | 'SKIP_REPORTEE';
  }>;
};

export const createOneOnOneApi = ({ employeeId, startTimeTs, duration, recurrenceRule }) => {
  const url = endpoints.oneOnOneRevamped.create;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: { employeeId, startTimeTs, duration, recurrenceRule },
  });
};

export const getExistingOneOnOneListApi = () => {
  const url = endpoints.oneOnOneRevamped.getExistingOneOnOneList;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const agendaRecommendationsApi = ({ masterId, instanceId }) => {
  const url = endpoints.oneOnOneRevamped.agendaRecommendations(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

export const completeMeetingApi = ({ masterId, instanceId, status }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.completeInstance(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      status,
    },
  });
};

export const markAsCompleteApi = ({ masterId, instanceId }: OneOnOneMarkAsCompleteRequest) => {
  const url = endpoints.oneOnOneRevamped.markAsComplete(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};
